import {HTTP_METHODS} from '@/utils/constants/httpMethods'

export const SKU_CONFIG = {
  SKU_CSV_DOWNLOAD: queryParams => ({
    endPoint: 'suggested-skus/export',
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
  }),
}
